// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"364":"57dc6873","400":"92083aa0","404":"d1b0d4f4","445":"12933bcf","473":"c7c85fef","588":"01057e81"}[chunkId] + ".chunk.js";
};